import OrderDetailsComponent from '../components/OrderDetails';

export default function OrderDetailsPage() {
  return <OrderDetailsComponent />;
}
